import { useCallback } from 'react';
import { ProjectParameters } from 'ducks/types/store-types';
import { default_input_parameter } from 'modals/constants';
import { parameterValidate } from 'utils/job';
import { v4 as uuidv4 } from 'uuid';

export const useConfiguredRows = () => {
  const getConfiguredRows = useCallback((rows: ProjectParameters) => {
    if (rows.length === 0) {
      return [{ uuid: uuidv4() }];
    }
    const length = rows.length - 1;
    const { modified } = rows[length];

    if (modified) {
      const default_inputs = { ...default_input_parameter, uuid: uuidv4() };
      rows.push(default_inputs);
    }

    return rows.map((r) => ({ ...r, error: parameterValidate(r) })).filter((row) => !row.delete);
  }, []);

  return { getConfiguredRows };
};
